module.exports = __webpack_public_path__ + "img/icon_egreso.3ae5739a.svg";